import React, { useContext } from 'react';
import { connect, getIn } from 'formik';
import { Box } from '@material-ui/core';

const ViewStackContext = React.createContext({ value: undefined });

const ViewStack: any = connect(({ name, children, formik: { values } }: any) => {
  const value = getIn(values, name);
  const context = {
    value,
  };

  return (
    <ViewStackContext.Provider value={context}>
      <Box>{children}</Box>
    </ViewStackContext.Provider>
  );
});

const View = ({ value, children }) => {
  const context = useContext(ViewStackContext);

  if (context.value === value) return children;

  return null;
};

ViewStack.View = View;

export default ViewStack;
